<template>
  <div>
    <Slidercomponent :lista="listaprops" />
  </div>
</template>

<script>
import Slidercomponent from "@/components/Slidercomponent.vue";

export default {
  name: "Herrevadsstrommen",
  components: {
    Slidercomponent
  },
  data() {
    return {
      listaprops: [
        {
          id: 0,
          rubrik: "Herrevadsströmmen",
          text:
            "If I fished only to capture fish, my fishing trips would have ended long ago. - Zane Grey",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-1.jpg"
        },
        {
          id: 1,
          rubrik: "Herrevadsströmmen",
          text:
            "Game fish are too valuable to only be caught once. - Lee Wulff",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-2.jpg"
        },
        {
          id: 2,
          rubrik: "Herrevadsströmmen",
          text:
            "The charm of fishing is that it is the pursuit of what is elusive but attainable, a perpetual series of occasions for hope. - John Buchan",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-5.jpg"
        },
        {
          id: 3,
          rubrik: "Herrevadsströmmen",
          text:
            "In the lexicon of the fly-fishermen, the words rise and hooked connote the successful and desirable climax; landing a fish is purely anticlimax. Vincent C. Marinaro-1950",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-6.jpg"
        },
        {
          id: 4,
          rubrik: "Herrevadsströmmen",
          text:
            "Ninety percent of what a trout eats is brown and fuzzy and about five-eighths of an inch long. - Allison Moir",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-7.jpg"
        },
        {
          id: 5,
          rubrik: "Herrevadsströmmen",
          text:
            "The climax in the poem of trouting, is the spring of the split bamboo. - Lewis France-1884",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-8.jpg"
        },
        {
          id: 6,
          rubrik: "Herrevadsströmmen",
          text:
            "They say you forget your troubles on a trout stream, but that's not quite it. What happens is that you begin to see where your troubles fit into the grand scheme of things, and suddenly they're just not such a big deal anymore. - John Gierach",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-9.jpg"
        },
        {
          id: 7,
          rubrik: "Herrevadsströmmen",
          text:
            "My biggest worry is that my wife (when I'm dead) will sell my fishing gear for what I said I paid for it. - Koos Brandt",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-11.jpg"
        },
        {
          id: 8,
          rubrik: "Herrevadsströmmen",
          text:
            "If you've got short, stubby fingers and wear reading glasses, any relaxation you would normally derive from fly fishing is completely eliminated when you try to tie on a fly. - Jack Ohman, - 1988",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-12.jpg"
        },
        {
          id: 9,
          rubrik: "Herrevadsströmmen",
          text:
            "The fishing was good; it was the catching that was bad. - A.K. Best",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-15.jpg"
        },
        {
          id: 10,
          rubrik: "Herrevadsströmmen",
          text: "",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-19.jpg"
        },
        {
          id: 11,
          rubrik: "Herrevadsströmmen",
          text: "",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-20.jpg"
        },
        {
          id: 12,
          rubrik: "Herrevadsströmmen",
          text: "",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-herrevadsstrommen/Herrevad-24.jpg"
        }
      ]
    };
  }
};
</script>
